<template>
    <pulse-loader class="w-100 text-center loader" :loading="loading" :color="color" :size="size"></pulse-loader>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    export default {
        components: {
            PulseLoader,
        },
        props: {
            loading : {
                type: Boolean,
                required: true
            },
            color: {
                type: String,
                default: function () {
                    return '#4da7d6'
                }
            },
            size: String,
        },
    }
</script>
